import {appFeature} from './app.reducers';
import {createSelector} from '@ngrx/store';
import {AppLayoutType} from '../../services/app-layout';

export const {
	selectLayout
} = appFeature;

export const selectIsMobileLayout = createSelector(
	selectLayout,
	(layout: AppLayoutType | null) => (layout ?? AppLayoutType.MD) < AppLayoutType.MD
);
